import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        "sort": {
            "attributes": ["id"],
            "sorts": ["desc"]
        },
        "filters":[ 
        ] ,
        "pageNo": 1,
        "itemsPerPage": 20
    },
};

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        updateFilter: (state, action) => {
            state.filters = action.payload;
        },
        updateReducer: (state, action) => {
            state.filters = action.payload;
        },
    },
});

export const {
    updateFilter,
    updateReducer,
} = notificationSlice.actions;

export default notificationSlice.reducer;
